import { motion } from "motion/react";

interface SoftProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export function SoftProgressBar({ currentStep, totalSteps }: SoftProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm opacity-60">
          Spørgsmål {currentStep} af {totalSteps}
        </span>
        <span className="text-sm opacity-60">{Math.round(progress)}%</span>
      </div>
      <div className="h-1.5 bg-[var(--soft-grey)] rounded-full overflow-hidden bg-[#ffffff]">
        <motion.div
          className="h-full rounded-full bg-[#006571]"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        />
      </div>
    </div>
  );
}